export const iconSmall = {
  width: "16px",
  height: "16px",
  minHeight: "16px",
  minWidth: "16px",
};
